export var CheckoutSdkHostEventType;
(function (CheckoutSdkHostEventType) {
    CheckoutSdkHostEventType["Initialize"] = "initialize";
    CheckoutSdkHostEventType["TokenisePaymentMethod"] = "tokenisePaymentMethod";
    CheckoutSdkHostEventType["AuthorizePayment"] = "authorizePayment";
    CheckoutSdkHostEventType["Disable"] = "disable";
    CheckoutSdkHostEventType["Enable"] = "enable";
    CheckoutSdkHostEventType["ClickOutside"] = "clickOutside";
    CheckoutSdkHostEventType["HostAuthComplete"] = "hostAuthComplete";
    CheckoutSdkHostEventType["PaymentComplete"] = "paymentComplete";
    CheckoutSdkHostEventType["SetErrorMessage"] = "setErrorMessage";
    CheckoutSdkHostEventType["CompletePayment"] = "completePayment";
    CheckoutSdkHostEventType["CreateCustomer"] = "createCustomer";
    CheckoutSdkHostEventType["AuthorizeApplePayComplete"] = "authorizeApplePayComplete";
    CheckoutSdkHostEventType["GetGooglePayToken"] = "getGooglePayToken";
    CheckoutSdkHostEventType["GenerateRedirectUrl"] = "generateRedirectUrl";
    CheckoutSdkHostEventType["HandleSecureAuthentication"] = "handleSecureAuthentication";
})(CheckoutSdkHostEventType || (CheckoutSdkHostEventType = {}));
//# sourceMappingURL=checkout-sdk-host-event-type.js.map